import { render, staticRenderFns } from "./LearningSituation.vue?vue&type=template&id=7e8b218b&scoped=true&lang=pug&"
import script from "./LearningSituation.vue?vue&type=script&lang=ts&"
export * from "./LearningSituation.vue?vue&type=script&lang=ts&"
import style0 from "./LearningSituation.vue?vue&type=style&index=0&id=7e8b218b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8b218b",
  null
  
)

export default component.exports